import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { RxComposite } from '../model/rx-composite';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxTipModule } from '@nrwl/rx-tip';
import { RxCheckboxModule } from '@nrwl/rx-checkbox';

@Component({
  selector: 'rx-text-composite',
  templateUrl: './rx-text-composite.component.html',
  styleUrls: ['./rx-text-composite.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule, RxTipModule, RxCheckboxModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxTextCompositeComponent extends RxComposite {
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  public getHtml(string) {
    return this.sanitizer.bypassSecurityTrustHtml(string);
  }

  public onDontShowAgainChanged($event) {
    this.payload.showAgainSettings = { value: $event };
  }
}
